import Hero from "@/components/waylio/Hero";

export default function HomePage() {
  return <Hero />;
}
